import React from 'react';

const Credits = () => {
    return(
        <div id="credits">
            <p>
                I would like to dedicate this to my family and fiance Claire as I couldn't have done this without your support. 
            </p>
            <p>
                Thank you to Matthew Williams, Robert Pedersen and Peter Viss for their inputs and being my live rubber ducks since my rubber duck wasn't enough, you guys are the bros!. Keith Burgie for the CSS lessons and advices. The Flatiron instructors, Paul and Ann on teaching us to build apps and to our coaches Joseph and Jenny to lead us here.
            </p>
            <p>
                Font credits goes to: Daniel Linsenn
                <br></br>
                -<a href="https://managore.itch.io/">https://managore.itch.io/</a>
            </p>
            <p>
                Sprite credits goes to: 0x72 :
                <br></br>
                -<a href="https://0x72.itch.io/dungeontileset-ii">https://0x72.itch.io/dungeontileset-ii</a>
            </p>

        </div>
    )
}

export default Credits